import { render } from "./SettingsPractitioner.vue?vue&type=template&id=f337faf4&scoped=true"
import script from "./SettingsPractitioner.vue?vue&type=script&lang=js"
export * from "./SettingsPractitioner.vue?vue&type=script&lang=js"

import "./SettingsPractitioner.vue?vue&type=style&index=0&id=f337faf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f337faf4"]])

export default __exports__